import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {RequestServiceProvider} from '../../providers/request-service/request-service';
import {DummyDataProvider} from "../../providers/dummy-data/dummy-data";
import {Subscription} from "rxjs";
import {EventDetailsPage} from "../event-details/event-details";

/**
 * Generated class for the EventsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface Tab {
  name: string,
  title: string
}

@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})
export class EventsPage {

  public tabs: Tab[] = [
    {name: 'active', title: 'Active'},
    {name: 'soon', title: 'Coming Soon'},
    {name: 'closed', title: 'Closed'},
  ];
  public loading: boolean = false;
  public events = [];
  public underlineStyle = {};
  public activeTab;
  public dataSubscription: Subscription;

  constructor(public navCtrl: NavController, public navParams: NavParams, private request: RequestServiceProvider, private dataProvider: DummyDataProvider) {
  }

  activateTab(tab: Tab) {
    this.activeTab = tab;
  }

  isActiveTab(tab: Tab) {
    return this.activeTab == tab;
  }

  getId(tab) {
    return `${tab.name}-tab-item`
  }

  setUnderlineStyles(tab) {
    const el = document.getElementById(this.getId(tab));
    const width = el.offsetWidth, left = el.offsetLeft;
    this.underlineStyle = {
      transform: `translateX(${left}px)`,
      width: `${width}px`
    }
  }

  handleTabClick(tab) {
    console.log(tab);
    this.activateTab(tab);
    this.setUnderlineStyles(tab);
    // Apply filtering mechanism
    this.fetchData(tab)
  }

  navigateDetailPage(event){
    this.navCtrl.push(EventDetailsPage, {event})
  }
  fetchData(tab) {
    this.loading = true;
    this.activateTab(tab);
    this.request.getEvents(tab.name).subscribe(data => {
    
      data.forEach((item, index) => {
       data[index].progress = this.calcProgress(data[index].prog)
      })

      this.events = data ;
     
      this.loading = false;
    });

  }

  calcProgress(allAccCount){
    let totalCount = 0

    allAccCount.forEach(item => {
     totalCount = totalCount + item.count ;
    })

    const agent = allAccCount.find(item => item.agent_code === window.localStorage.getItem('agentCode'))

    if(agent !== undefined)  return Math.round(((agent.count / totalCount) * 100 ));

    return 0 
   
}

  ionViewDidLoad() {
    this.handleTabClick(this.tabs[0])
  }

  setUnderline() {
  }

 

}



// WEBPACK FOOTER //
// ./src/pages/events/events.ts